import posthog from 'posthog-js';

let _initialized = false;

export function initCore(
  apiKey: string,
  host: string,
  recordSessions: boolean,
  debug: boolean,
): void {
  if (_initialized) {
    if (debug) console.warn('[Argus] Already initialized — skipping duplicate init.');
    return;
  }

  posthog.init(apiKey, {
    api_host: host,
    autocapture: false,        // We handle our own click tracking
    capture_pageview: false,   // We handle our own pageview tracking
    disable_session_recording: !recordSessions,
    loaded(ph) {
      if (debug) {
        console.log('[Argus] PostHog loaded ✅', ph.get_distinct_id());
      }
    },
  });

  _initialized = true;
}

export function isInitialized(): boolean {
  return _initialized;
}
